export default {
  common: {
    loading: 'Carregando...',
    noData: 'Sem dados disponíveis.',
  },
  nav: {
    home: 'Início',
    products: 'Produto',
    about: 'Sobre Nós',
    partnership: 'Parceria',
    blog: 'Blog',
  },
  home: {
    text: 'INÍCIO',
    title: 'YOOXPLORE',
    hero: {
      title1: 'Capacitando Parceiros Globais',
      title2: 'Protegendo o Futuro a Partir do Ar',
      bookDemo: 'Agendar Demo',
    },
  },
  overview: {
    title: 'Visão Geral',
    subtitle: 'Plataforma UAV YOOX S3T',
    content: 'O YOOX S3T é um veículo aéreo não tripulado (VANT) avançado capaz de transportar cargas pesadas, voar com estabilidade e manobrar com precisão. Projetado para ser um dos melhores drones autônomos do mercado, destaca-se pelo longo tempo de voo e pelo excelente desempenho de longo alcance, sendo ideal para operações militares, tarefas industriais e missões humanitárias.',
    content2: 'Além de vender drones, ajudamos a sua marca de drones a ter sucesso localmente. Oferecemos soluções de produção e montagem localizadas, ajudando-o a construir seu próprio sistema de produção para fabricar os melhores drones e alcançar seus objetivos.',
  },
  scenarios: {
    title: 'Cenários',
    subtitle: 'Expansível para mais casos de uso industrial',
  },
  advantages: {
    title: 'Principais Vantagens',
    subtitle: 'Projetado para escalar conforme suas necessidades',
  },
  products: {
    title: 'Centro de Produtos',
    intro: 'Introdução de Produtos',
    subtitle: 'Plataformas de Voo de Nível Industrial e Produtos Ecológicos',
    gallery: {
      all: 'Todos',
    },
    contact_business: 'Entre em contato conosco para mais detalhes do produto',
  },
  about: {
    text: 'Sobre Nós',
    title: 'Sobre Nós',
    teamTitle: 'Nossa Equipe',
    teamSubtitle: 'De empresas líderes globais',
    teamContent: 'Nossa equipe vem de empresas como DJI, Yamaha, Apple, Tesla, etc. Temos em média mais de dez anos de experiência na indústria de drones e nos campos de segurança e defesa.',
    visionTitle: 'Nossa Visão',
    visionSubtitle: 'Ajudamos sua marca de drones a ter sucesso localmente',
    visionContent: 'Além de vender drones, fornecemos soluções de produção e montagem localizadas, ajudando-o a construir seu sistema de produção próprio para fabricar os melhores drones e alcançar seus objetivos.',
  },
  partnership: {
    title: 'Parceria',
    primaryCta: 'Atacado & ODM & OEM',
    secondaryCta: 'Torne-se um Distribuidor',
    qaTitle: 'Perguntas Frequentes',
  },
  blog: {
    title: 'Blog',
    heading: 'Perspectivas e Atualizações',
    subheading: 'As últimas novidades em drones, localização e tendências de mercado.',
    searchPlaceholder: 'Pesquisar artigos',
  },
  contact: {
    title: 'Entre em Contato',
    title2: 'Adoraríamos ouvir de você.',
    content1: 'Se deseja mais informações ou cooperar conosco, entre em contato via WhatsApp, Telegram ou pelo formulário.',
    whatsappLabel: 'WhatsApp',
    whatsappValue: 'WhatsApp: <YOUR_WHATSAPP>',
    telegramLabel: 'Telegram',
    telegramValue: 'Telegram: <YOUR_TELEGRAM>',
    form: {
      title: 'Formulário de Contato',
      subtitle: 'Adoraríamos ouvir de você.',
      firstName: 'Nome',
      lastName: 'Sobrenome',
      email: 'E-mail',
      phone: 'Telefone',
      company: 'Empresa',
      country: 'País/Região',
      interestLabel: 'Estou interessado em',
      interests: ['Compra de produtos', 'Tornar-se distribuidor', 'OEM/ODM', 'Consultoria técnica', 'Outro'],
      message: 'Suas necessidades e descrição',
      submit: 'Enviar',
      submitTip: 'Obrigado pelo contato. Responderemos em breve.',
      submitError: 'Falha no envio. Por favor, tente novamente.',
    },
  },
}
